import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    report: [],
    reportLoading: false,
  },
  mutations: {
    setReport(state, payload) {
      state.report = payload;
    },
    setReportLoading(state, payload) {
      state.reportLoading = payload;
    },
  },
  actions: {
    async loadReport({ commit }, params) {
      commit("setReportLoading", true);
      let list = await api.get("/sustainability/reporting/storyReport", {
        params: params,
      });
      commit("setReport", list.data);
      commit("setReportLoading", false);
    },
  },
  getters: {
    report(state) {
      return state.report;
    },
    reportLoading(state) {
      return state.reportLoading;
    },
  },
};
